import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../store";
import { Loader } from "./loader";
import Select from "react-select";
import moment from "moment";

import {fetchRecentChangeLogs} from '../actions/changeLog';


const $ = window.$;

class ViewChangeLog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recentChangeLogList : []
          };      
    }

  closeModal = () => {
    $("#view_change_log").modal("hide");
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.data.changeLogReducer.recentChangeLogs !== nextProps.data.changeLogReducer.recentChangeLogs) {
      this.setState({ recentChangeLogList: nextProps.data.changeLogReducer.recentChangeLogs });
    }
    if (this.props.data.changeLogReducer.setChangeLog !== nextProps.data.changeLogReducer.setChangeLog) {
      this.props.fetchRecentChangeLogs();
    }
    if (this.props.data.changeLogReducer.selectedToDelete !== nextProps.data.changeLogReducer.selectedToDelete) {
      this.props.fetchRecentChangeLogs();
    }
  }

  componentDidMount(){
    this.props.fetchRecentChangeLogs();
  }

render() {
    return (
        <div
        className="modal fade show"
        id="view_change_log"
        tabIndex="-1"
        role="dialog"
      >
           <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  What's New
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
            <div className="m-portlet">								
									<div className="m-portlet__body">				
														<div className="m-list-search">
															<div className="m-list-search__results">
																<span className="m-list-search__result-message m--hide">
																	No record found
																</span>																                              															
                                    {this.state.recentChangeLogList.map((log , index) => (
                                      <div key={index}> 
                                       <span className="m-list-search__result-category m-list-search__result-category--first">
                                          Version - {log.version} {" "} (Released On {moment(log.release_date).format('YYYY-MM-DD')}) {log.video_link ? (<><strong> - [ </strong><a target="_blank" href={log.video_link}> DEMO <i className="fa fa-video"></i></a><strong> ] </strong></>): null}                
                                      </span>
                                      <div className="mt-10">
                                        <ol>
                                          {log.ChangeLogNotes.map((note , i) =>(
                                            <li key={i}>{note.text}</li>
                                          ))}
                                        </ol>
                                      </div>
                                      </div>
                                    ))}
															</div>
														</div>						
									</div>
								</div>
            </div>   
            
        </form>
        </div>
        </div>
      </div>
    )
}

}

const mapStateToProps = state => ({
      data : state
  });
  
  const mapDispatchToProps = dispatch => ({
    fetchRecentChangeLogs: () => {
      dispatch(fetchRecentChangeLogs());
    },
  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ViewChangeLog)
  );